// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3jOks","tab":"Tabs_tab__1kLzg","tabActive":"Tabs_tabActive__2uC18"};